/**
 * Plain-text lines for addresses returned by the API.
 * Matches GraphQL `Address` in
 * `KivuIMSProxyService/src/main/resources/graphql/types.graphqls`
 * (used on `Store`, `Company`, customer `address`, etc.).
 */
export type GraphqlAddressLike = {
  country?: string | null;
  province?: string | null;
  district?: string | null;
  sector?: string | null;
  cell?: string | null;
  village?: string | null;
  streetAddress?: string | null;
};

const trim = (v?: string | null): string => (v?.trim() ? v.trim() : "");

/**
 * Renders `Address` fields as printable lines (e.g. invoice bill-to, store header).
 * Order follows common mailing layout: street → cell/village → sector/district → province/country.
 */
export function formatAddressToLines(
  address: GraphqlAddressLike | null | undefined
): string[] {
  if (!address) return [];
  const lines: string[] = [];
  const street = trim(address.streetAddress);
  if (street) lines.push(street);
  const cellVillage = [trim(address.cell), trim(address.village)]
    .filter(Boolean)
    .join(", ");
  if (cellVillage) lines.push(cellVillage);
  const sectorDistrict = [trim(address.sector), trim(address.district)]
    .filter(Boolean)
    .join(", ");
  if (sectorDistrict) lines.push(sectorDistrict);
  const region = [trim(address.province), trim(address.country)]
    .filter(Boolean)
    .join(", ");
  if (region) lines.push(region);
  return lines;
}
